import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";

export interface CloseUnconvertLead extends GtagEvent {
    currency:ISO_4217;
    value: number;
    unconvert_lead_reason?:string;
}
export const close_unconvert_lead = ($_:CloseUnconvertLead) => event('close_unconvert_lead',$_);